<div class="form-section">
	<div class="form-group">
		@if (!hideName) {
			<mat-form-field appearance="outline" class="full-width">
				<mat-label translate="activity-editor-new_activity-name-input-label"></mat-label>
				<input
					matInput
					type="text"
					[formControl]="activityFormService.getControl('name')"
					data-cy="activity-name-input"
					maxlength="255">
				@if (activityFormService.getControl('name').invalid && activityFormService.getControl('name').touched) {
					<mat-error>
						@if (activityFormService.getControl('name').errors?.['required']) {
							<span translate="activity-editor-new_form-validation-error-name-required"></span>
						} @else if (activityFormService.getControl('name').errors?.['maxlength']) {
							<span translate="activity-editor-new_form-validation-error-name-max-length"></span>
						}
					</mat-error>
				}
			</mat-form-field>
		}
	</div>

	<activity-type-dropdown
		[activity]="activity"
		[template]="selectedTemplate"
		(onTemplateSelect)="handleTemplateSelect($event)">
	</activity-type-dropdown>

	@if (shouldShowSourceMediaSetting()) {
		<source-media-setting
			[selectedTemplate]="selectedTemplate"
			[activity]="activity"
			[sourceMediaControl]="activityFormService.getControl('source_media')"
			[hasSelfSelectSourceMediaControl]="activityFormService.getControl('has_self_select_source_media')"
			[sourceTypeControl]="activityFormService.getControl('source_type')">
		</source-media-setting>
	}

	@if (!hideDates) {
		<div class="form-group date-picker-group">
			<ngx-datetime-picker
				[property]="'available_at'">
			</ngx-datetime-picker>
			<ngx-datetime-picker
				[property]="'due_at'">
			</ngx-datetime-picker>
		</div>
	}

	@if (activity.isViewable('use_score')) {
		<activity-grading [activity]="activity" [rubricRole]="'instructor'"></activity-grading>
	}

	<activity-edit-ai-markers-section
		[activity]="activity">
	</activity-edit-ai-markers-section>

	<ngx-activity-edit-marker-section
		[activity]="activity">
	</ngx-activity-edit-marker-section>

	<activity-attachments
		[activity]="activity">
	</activity-attachments>
</div>
